import React from 'react'

import { IQuestionViewProps } from '../types'
import { InstructionQuestionModelTypes } from './types'

import style from './style.module.scss'
import commonStyle from '../../questions/_common/style.module.scss'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import TextWithOptions from '@aytm/app/swidget/base/modules/preview/components/TextWithOptions'
import DeviceSwitchLink from './components/DeviceSwitchLink'
import usePreviewOptions from '@aytm/app/swidget/base/modules/preview/usePreviewOptions'
import useSession from '@aytm/app/swidget/base/session/useSession'
import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'

const InstructionView = ({ schema }: IQuestionViewProps<InstructionQuestionModelTypes>) => {
  const viewport = useViewport() // Still needed for mobile class
  const session = useSession()
  const previewOptions = usePreviewOptions()
  const { localeOptions } = useInterfaceLocale()
  const text = schema.answers[0].text
  const textParts = schema.dead_end
    ? text.includes('{{window.location+qr}}')
      ? text.split('{{window.location+qr}}')
      : text.includes('{{window.location}}')
        ? text.split('{{window.location}}')
        : [text]
    : [text]

  return (
    <section
      className={`${style.instructionView} ${localeOptions.rtl ? style.instructionViewRTL : ''} ${
        viewport.mobile ? ' ' + style.mobile : ''
      } `}
      data-testid="SW-IT"
      role="region"
      aria-label="Instruction"
    >
      <div id="it-questionNote" className={commonStyle.srOnly}>
        {schema.text}
      </div>

      <div role="note" aria-describedby="it-questionNote">
        {textParts.length > 1 ? (
          <div>
            <TextWithOptions
              text={textParts[0]}
              options={previewOptions}
              rules={session.rules?.sub?.[schema.id]?.[`${schema.id}a1`]}
            />

            {schema.dead_end ? <DeviceSwitchLink showQR={text.includes('{{window.location+qr}}')} /> : null}
            <TextWithOptions
              text={textParts[1]}
              options={previewOptions}
              rules={session.rules?.sub?.[schema.id]?.[`${schema.id}a1`]}
            />
          </div>
        ) : (
          <TextWithOptions
            text={schema.answers?.[0].text || ''}
            options={previewOptions}
            rules={session.rules?.sub?.[schema.id]?.[`${schema.id}a1`]}
          />
        )}
      </div>
    </section>
  )
}

export default InstructionView
